<template>
  <div id="app" data-v-app>
    <van-sticky>
      <van-nav-bar
        style="background-color: #3f78f6"
        title=""
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      >
        <template #title>
          <span style="color: white; font-size: 0.4rem">信息提醒</span>
        </template>
        <template #left>
          <van-icon name="arrow-left" color="white" size="18" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- 内容循环操作-->
    <section class="van-doc-demo-section">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="jobItems"
          v-for="item in list"
          :key="item.id"
          @click="onBackMes(item.id, item.backContent)"
        >
          <table border="0" style="font-size: 0.4rem; margin: 0 0.5rem">
            <tr>
              <td rowspan="3">
                <van-image
                  :src="require('@/image/notity.png')"
                  round
                  width="1rem"
                  height="1rem"
                  style="margin-right: 0.3rem"
                >
                </van-image>
              </td>
              <td colspan="2" style="text-align: left; color: #666666">
                {{ item.ftime }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: left">{{ item.ftitle }}</td>
            </tr>
            <tr>
              <td style="text-align: left; color: #666666">
                {{ item.fcontent }}
              </td>
              <td>
                <van-tag
                  round
                  type="primary"
                  style="
                    font-size: 0.4rem;
                    width: 2rem;
                    height: 0.6rem;
                    text-align: center;
                    padding-top: 0.2rem;
                    display: block;
                    color: white;
                    background-color: #3f78f6;
                    position: absolute;
                    top: 1rem;
                    right: 01rem;
                    left: 7.2rem;
                    border-radius: 0.585185rem;
                  "
                  >{{ item.messageState }}</van-tag
                >
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      backMess: "",
      list: [],
      shenfen: "",
      student: "",
      page: "",
    };
  },
  created() {
    this.student = this.$route.query.student;
    this.page = this.$route.query.page;
    console.log(
      "传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page
    );
    var json = window.localStorage.getItem("User");
    var jsonObj = JSON.parse(json);
    console.log("身份:" + jsonObj[0]["shenfen"]);
    var code;
    if (jsonObj[0]["shenfen"] == "老师" || jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else if (jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else {
      code = jsonObj[0]["phone"];
    }
    code;
    this.shenfen = jsonObj[0]["shenfen"];
    var params_json = {
      userid: this.student,
      action: "noticeList",
      param1: "",
      param2: "",
      param3: "",
      param4: "",
      param5: "",
    };

    this.$http.post("/web/list", params_json).then(function (res) {
      // let obj = res.data["rows"];
      console.log(res.data["rows"]);
      this.list = res.data["rows"];
    });
    this.onLoad();
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "Index",
        query: {
          page: this.page,
        },
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
    onBackMes(id, backContent) {
      this.$router.push({
        path: "WeChatBack",
        query: {
          shenfen: this.shenfen,
          id: id,
          backContent: backContent,
          page: this.page,
          student: this.student,
        },
      });
    },
  },
};
</script>

<style>
.jobItems {
  padding: 0.3rem 0;
  border-bottom: 0.2rem solid #eaeaea;
  position: relative;
}

ul.areaUi {
  height: 0.3rem;
  margin: 0 0 0.2rem 0.2rem;
}

ul.areaUi li {
  float: left;
  margin-right: 0.1rem;
}

.jobItems h1 {
  font-size: 0.5rem;
  font-weight: bold;
  margin: 0 0 0.1rem 0.7rem;
}

.jobItems p {
  font-size: 0.5rem;
  color: #666;
  margin: 0 0 0.1rem 0.7rem;
}

.jobItems span {
  font-size: 0.5rem;
  color: #666;
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
}
</style>